import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  text-align: left;\n  border-collapse: collapse;\n  font-size: 90%;\n\n  tr {\n    background-color: transparent;\n  }\n\n  td,\n  th {\n    padding: 2 3;\n  }\n\n  th {\n    color: on-background-light;\n    background-color: background-light;\n    font-weight: 600;\n    z-index: 20;\n    position: sticky;\n    top: 0;\n  }\n\n  td {\n    font-size: 85%;\n    border-top: 1;\n    border-bottom: 1;\n    border-color: layout-border;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      max-height: 480;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow-y: auto;\n  margin: 3 0 2;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { up, css } from '@xstyled/styled-components';
export var TableContainer = styled.div(_templateObject(), up('lg', css(_templateObject2())));
export var Table = styled.table(_templateObject3());